import React from 'react';
import * as Recharts from 'recharts';

// recharts 3.x return-type inference vs React 18 JSX types trips PolarAngleAxis /
// PolarRadiusAxis with TS2786 ('cannot be used as a JSX component'). Cast to any
// at import — runtime is unchanged; only TS static check is bypassed.
const ResponsiveContainer: any = Recharts.ResponsiveContainer;
const RadarChart: any        = Recharts.RadarChart;
const PolarGrid: any         = Recharts.PolarGrid;
const PolarAngleAxis: any    = Recharts.PolarAngleAxis;
const PolarRadiusAxis: any   = Recharts.PolarRadiusAxis;
const Radar: any             = Recharts.Radar;
const Tooltip: any           = Recharts.Tooltip;

interface AxisPoint {
  axis: string;
  value: number;
}

interface Props {
  data: AxisPoint[];
}

const RiskProfileRadar: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className="chart-empty">No radar data.</div>;
  }
  return (
    <div className="chart-container">
      <ResponsiveContainer width="100%" height={195}>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#334155" />
          <PolarAngleAxis
            dataKey="axis"
            tick={{ fill: '#cbd5e1', fontSize: 11 }}
          />
          <PolarRadiusAxis
            domain={[0, 100]}
            tick={{ fill: '#64748b', fontSize: 10 }}
            angle={90}
          />
          <Radar
            dataKey="value"
            stroke="#3b82f6"
            fill="#3b82f6"
            fillOpacity={0.4}
          />
          <Tooltip
            contentStyle={{ background: '#0f172a', border: '1px solid #334155', borderRadius: 4, fontSize: 12 }}
            formatter={(v: any) => [`${Number(v).toFixed(0)}/100`, 'score']}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RiskProfileRadar;
